/**
 * Workspace switcher stub -- no workspaces in stripped mode.
 * Renders nothing, keeping the taskbar layout intact.
 */
export function WorkspaceSwitcher() {
	return <div className="flex items-center px-1.5" />;
}
